import type { HTTP } from "@/core/http";
import type {
  AdminMetadata,
  Role,
  RoleHistory,
  RoleRequest,
  RoleUpdateRequestBody,
} from "../types";

export class RoleService {
  constructor(private readonly httpClient: HTTP) {}

  async getRoles(): Promise<Role[]> {
    return this.httpClient.get<Role[]>("/platform/roles");
  }

  async getRoleMetadata(): Promise<AdminMetadata> {
    return this.httpClient.get<AdminMetadata>("/platform/roles/metadata");
  }

  async getRole(roleId: number): Promise<Role> {
    return this.httpClient.get<Role>(`/platform/roles/${roleId}`);
  }

  async createRole(data: RoleRequest): Promise<Role> {
    return this.httpClient.post<Role, RoleRequest>("/platform/roles", {
      body: data,
    });
  }

  async updateRole(
    roleId: number,
    data: RoleUpdateRequestBody,
  ): Promise<Role> {
    return this.httpClient.put<Role, RoleUpdateRequestBody>(
      `/platform/roles/${roleId}`,
      { body: data },
    );
  }

  async getRoleHistory(roleId: number): Promise<RoleHistory[]> {
    return this.httpClient.get<RoleHistory[]>(
      `/platform/roles/${roleId}/history`,
    );
  }
}

export type { Role };
